"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = ["data-tooltip"];
const _hoisted_2 = {
    key: 0,
    class: "colony-spaceship"
};
const _hoisted_3 = { class: "colony-card-title-div" };
const _hoisted_4 = {
    class: "colony-content",
    style: 'margin-top: {{colonyContentOffset}}px;'
};
const _hoisted_5 = {
    key: 2,
    class: "resource card card-with-border",
    style: { "transform": "scale(0.8)" }
};
const _hoisted_6 = {
    key: 4,
    class: "resource money"
};
const _hoisted_7 = {
    key: 5,
    class: "resource wild",
    style: { "margin": "15px 10px 10px 20px" }
};
const _hoisted_8 = {
    key: 6,
    style: { "display": "inline-block" }
};
const _hoisted_9 = { style: { "display": "inline-block", "margin-left": "10px", "font-size": "14px" } };
const _hoisted_10 = { style: { "font-size": "14px", "margin-left": "10px" } };
const _hoisted_11 = {
    key: 9,
    class: "deimos-colony-bonus"
};
const _hoisted_12 = { class: "colony-background-color" };
const _hoisted_13 = { key: 0 };
const _hoisted_14 = { key: 1 };
const _hoisted_15 = {
    key: 12,
    class: "tile rating",
    style: { "margin-left": "20px", "transform": "scale(0.8)", "margin-top": "-10px" }
};
const _hoisted_16 = {
    key: 13,
    class: "resource card card-with-border",
    style: { "margin-left": "20px", "transform": "scale(0.8)", "margin-top": "-8px" }
};
const _hoisted_17 = {
    key: 14,
    style: { "height": "20px", "visibility": "hidden", "display": "block" }
};
const _hoisted_18 = {
    key: 15,
    class: "white-x",
    style: { "margin-left": "-42px" }
};
const _hoisted_19 = {
    key: 16,
    class: "white-x",
    style: { "margin-left": "42px" }
};
const _hoisted_20 = {
    key: 17,
    class: "points points-big",
    style: { "margin-left": "10px", "margin-top": "-53px", "transform": "scale(0.5)", "height": "50px", "width": "50px" }
};
const _hoisted_21 = {
    key: 18,
    class: "white-x",
    style: { "margin-left": "52px", "margin-right": "-30px" }
};
const _hoisted_22 = {
    key: 19,
    class: "delegate",
    style: { "margin-top": "-23px", "margin-right": "5px" }
};
const _hoisted_23 = {
    key: 20,
    class: "white-x",
    style: { "margin-left": "45px", "margin-bottom": "4px" }
};
const _hoisted_24 = {
    key: 21,
    class: "resource wild",
    style: { "margin": "10px 10px 10px -20px" }
};
const _hoisted_25 = {
    key: 22,
    class: "resource card",
    style: { "margin-left": "5px", "transform": "scale(0.8)" }
};
const _hoisted_26 = {
    key: 0,
    class: "colony-background-color",
    style: { "position": "relative", "top": "-3px" }
};
const _hoisted_27 = {
    key: 1,
    class: "colony-background-color",
    style: { "margin-left": "3px", "position": "relative", "top": "-12px" }
};
const _hoisted_28 = {
    key: 2,
    class: "colony-background-color",
    style: { "position": "relative", "top": "-8px", "left": "30px" }
};
const _hoisted_29 = {
    key: 3,
    class: "colony-background-color",
    style: { "position": "relative", "top": "-14px", "left": "12px" }
};
const _hoisted_30 = {
    key: 4,
    class: "colony-background-color",
    style: { "margin-left": "3px" }
};
const _hoisted_31 = {
    key: 5,
    class: "colony-background-color",
    style: { "margin-left": "3px" }
};
const _hoisted_32 = {
    key: 6,
    class: "colony-background-color",
    style: { "margin-left": "3px" }
};
const _hoisted_33 = {
    key: 7,
    class: "colony-background-color",
    style: { "margin-left": "3px" }
};
const _hoisted_34 = {
    key: 8,
    class: "colony-background-color"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_colony_row = (0, vue_1.resolveComponent)("colony-row");
    const _component_colony_trade_row = (0, vue_1.resolveComponent)("colony-trade-row");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
        class: (0, vue_1.normalizeClass)(["filterDiv colony-card colonies tooltip tooltip-bottom", _ctx.backgroundClass]),
        "data-tooltip": _ctx.tooltip
    }, [
        (_ctx.colony.visitor !== undefined)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, [
                (0, vue_1.createElementVNode)("div", {
                    class: (0, vue_1.normalizeClass)('colonies-fleet colonies-fleet-' + _ctx.colony.visitor)
                }, null, 2)
            ]))
            : (0, vue_1.createCommentVNode)("", true),
        (0, vue_1.createElementVNode)("div", _hoisted_3, [
            (0, vue_1.createElementVNode)("span", {
                class: (0, vue_1.normalizeClass)(["colony-card-title-span", _ctx.colony.name + '-title'])
            }, (0, vue_1.toDisplayString)(_ctx.colony.name), 3)
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_4, [
            (_ctx.metadata.colony.type === _ctx.ColonyBenefit.GAIN_RESOURCES)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 0 }, [
                    (_ctx.metadata.colony.resource !== _ctx.Resource.MEGACREDITS)
                        ? ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 0 }, (0, vue_1.renderList)(_ctx.metadata.colony.quantity, (n) => {
                            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                key: n,
                                class: (0, vue_1.normalizeClass)(["resource", _ctx.metadata.colony.resource])
                            }, null, 2));
                        }), 128))
                        : ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                            key: 1,
                            class: (0, vue_1.normalizeClass)(["resource", _ctx.metadata.colony.resource])
                        }, (0, vue_1.toDisplayString)(_ctx.metadata.colony.quantity), 3))
                ], 64))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.metadata.colony.type === _ctx.ColonyBenefit.ADD_RESOURCES_TO_CARD)
                ? ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 1 }, (0, vue_1.renderList)(_ctx.metadata.colony.quantity, (n) => {
                    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                        key: n,
                        class: (0, vue_1.normalizeClass)(["resource", _ctx.colonyResourceClass])
                    }, null, 2));
                }), 128))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.colony.name === _ctx.ColonyName.MIRANDA)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_5))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.colony.name === _ctx.ColonyName.IAPETUS)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 3 }, [
                    _cache[0] || (_cache[0] = (0, vue_1.createElementVNode)("div", {
                        class: "resource card card-with-border",
                        style: { "transform": "scale(0.8)" }
                    }, null, -1)),
                    _cache[1] || (_cache[1] = (0, vue_1.createElementVNode)("span", { class: "white-char" }, ":", -1)),
                    _cache[2] || (_cache[2] = (0, vue_1.createElementVNode)("div", { class: "resource money" }, "-1", -1))
                ], 64))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.colony.name === _ctx.ColonyName.TITANIA)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_6, "-3"))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.colony.name === _ctx.ColonyName.VENUS)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_7, [...(_cache[3] || (_cache[3] = [
                        (0, vue_1.createTextVNode)("?", -1),
                        (0, vue_1.createElementVNode)("div", {
                            class: "card-icon tag-venus",
                            style: { "color": "white", "margin-top": "-36px", "margin-left": "16px" }
                        }, null, -1)
                    ]))]))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.colony.name === _ctx.ColonyName.PALLAS)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_8, [
                    _cache[5] || (_cache[5] = (0, vue_1.createElementVNode)("div", { class: "resource money" }, "1", -1)),
                    _cache[6] || (_cache[6] = (0, vue_1.createTextVNode)()),
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[4] || (_cache[4] = [
                            (0, vue_1.createTextVNode)("/ party", -1)
                        ]))])), [
                        [_directive_i18n]
                    ]),
                    _cache[7] || (_cache[7] = (0, vue_1.createTextVNode)()),
                    _cache[8] || (_cache[8] = (0, vue_1.createElementVNode)("div", { class: "delegate" }, null, -1))
                ]))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.colony.name === _ctx.ColonyName.LEAVITT)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 7 }, [
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_9, [...(_cache[9] || (_cache[9] = [
                            (0, vue_1.createTextVNode)("REVEAL TOP CARD OF DECK.", -1)
                        ]))])), [
                        [_directive_i18n]
                    ]),
                    _cache[11] || (_cache[11] = (0, vue_1.createElementVNode)("span", null, [
                        (0, vue_1.createElementVNode)("br")
                    ], -1)),
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_10, [...(_cache[10] || (_cache[10] = [
                            (0, vue_1.createTextVNode)("BUY OR DISCARD IT.", -1)
                        ]))])), [
                        [_directive_i18n]
                    ])
                ], 64))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.colony.name === _ctx.ColonyName.PLUTO)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 8 }, [
                    _cache[12] || (_cache[12] = (0, vue_1.createElementVNode)("span", {
                        class: "white-char",
                        style: { "margin-left": "5px" }
                    }, "+", -1)),
                    _cache[13] || (_cache[13] = (0, vue_1.createElementVNode)("div", {
                        class: "resource card card-with-border",
                        style: { "transform": "scale(0.8)", "margin-left": "-2px" }
                    }, null, -1)),
                    _cache[14] || (_cache[14] = (0, vue_1.createElementVNode)("span", { class: "white-char" }, "-", -1)),
                    _cache[15] || (_cache[15] = (0, vue_1.createElementVNode)("div", {
                        class: "resource card card-with-border",
                        style: { "transform": "scale(0.8)", "margin-left": "-2px" }
                    }, null, -1))
                ], 64))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.colony.name === _ctx.ColonyName.DEIMOS)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_11, [...(_cache[16] || (_cache[16] = [
                        (0, vue_1.createElementVNode)("div", { class: "resource money" }, "1", -1),
                        (0, vue_1.createTextVNode)(" / ", -1),
                        (0, vue_1.createElementVNode)("div", { class: "tile hazard-tile" }, null, -1)
                    ]))]))
                : (0, vue_1.createCommentVNode)("", true),
            (0, vue_1.createElementVNode)("span", _hoisted_12, [
                (_ctx.colony.name !== _ctx.ColonyName.TITANIA)
                    ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_13, [...(_cache[17] || (_cache[17] = [
                            (0, vue_1.createTextVNode)("Bonus", -1)
                        ]))])), [
                        [_directive_i18n]
                    ])
                    : (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_14, [...(_cache[18] || (_cache[18] = [
                            (0, vue_1.createTextVNode)("Colony Fee", -1)
                        ]))])), [
                        [_directive_i18n]
                    ])
            ]),
            _cache[31] || (_cache[31] = (0, vue_1.createElementVNode)("br", null, null, -1)),
            (_ctx.metadata.trade.type === _ctx.ColonyBenefit.GAIN_RESOURCES)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 10 }, [
                    (0, vue_1.createElementVNode)("div", {
                        style: { "margin-left": "20px" },
                        class: (0, vue_1.normalizeClass)(["resource", _ctx.metadata.trade.resource])
                    }, null, 2),
                    _cache[19] || (_cache[19] = (0, vue_1.createElementVNode)("div", { class: "white-x" }, null, -1))
                ], 64))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.metadata.trade.type === _ctx.ColonyBenefit.ADD_RESOURCES_TO_CARD)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 11 }, [
                    (0, vue_1.createElementVNode)("div", {
                        style: { "margin-left": "20px" },
                        class: (0, vue_1.normalizeClass)(["resource", _ctx.colonyResourceClass])
                    }, null, 2),
                    _cache[20] || (_cache[20] = (0, vue_1.createElementVNode)("div", { class: "white-x" }, null, -1))
                ], 64))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.colony.name === _ctx.ColonyName.IAPETUS)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_15))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.colony.name === _ctx.ColonyName.PLUTO)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_16))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.colony.name === _ctx.ColonyName.EUROPA)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_17))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.colony.name === _ctx.ColonyName.IAPETUS)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_18))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.colony.name === _ctx.ColonyName.TITANIA)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_19))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.colony.name === _ctx.ColonyName.TITANIA)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_20, " "))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.colony.name === _ctx.ColonyName.PALLAS)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_21))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.colony.name === _ctx.ColonyName.PALLAS)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_22))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.colony.name === _ctx.ColonyName.VENUS)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_23))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.colony.name === _ctx.ColonyName.VENUS)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_24, [...(_cache[21] || (_cache[21] = [
                        (0, vue_1.createTextVNode)("?", -1),
                        (0, vue_1.createElementVNode)("div", {
                            class: "card-icon tag-venus",
                            style: { "color": "white", "margin-top": "-36px", "margin-left": "16px" }
                        }, null, -1)
                    ]))]))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.colony.name === _ctx.ColonyName.LEAVITT)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_25))
                : (0, vue_1.createCommentVNode)("", true),
            (0, vue_1.createElementVNode)("template", null, [
                (_ctx.colony.name === _ctx.ColonyName.PLUTO)
                    ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_26, [...(_cache[22] || (_cache[22] = [
                            (0, vue_1.createTextVNode)("Trade Income", -1)
                        ]))])), [
                        [_directive_i18n]
                    ])
                    : (_ctx.colony.name === _ctx.ColonyName.EUROPA)
                        ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_27, [...(_cache[23] || (_cache[23] = [
                                (0, vue_1.createTextVNode)("Trade Income: Gain the indicated production", -1)
                            ]))])), [
                            [_directive_i18n]
                        ])
                        : (_ctx.colony.name === _ctx.ColonyName.IAPETUS)
                            ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_28, [...(_cache[24] || (_cache[24] = [
                                    (0, vue_1.createTextVNode)("Trade Income", -1)
                                ]))])), [
                                [_directive_i18n]
                            ])
                            : (_ctx.colony.name === _ctx.ColonyName.TITANIA || _ctx.colony.name === _ctx.ColonyName.PALLAS)
                                ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_29, [...(_cache[25] || (_cache[25] = [
                                        (0, vue_1.createTextVNode)("Trade Income", -1)
                                    ]))])), [
                                    [_directive_i18n]
                                ])
                                : (_ctx.colony.name === _ctx.ColonyName.MERCURY)
                                    ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_30, [...(_cache[26] || (_cache[26] = [
                                            (0, vue_1.createTextVNode)("Trade Income", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ])
                                    : (_ctx.colony.name === _ctx.ColonyName.HYGIEA)
                                        ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_31, [...(_cache[27] || (_cache[27] = [
                                                (0, vue_1.createTextVNode)("Trade Income: Steal 3 indicated resources", -1)
                                            ]))])), [
                                            [_directive_i18n]
                                        ])
                                        : (_ctx.colony.name === _ctx.ColonyName.LEAVITT)
                                            ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_32, [...(_cache[28] || (_cache[28] = [
                                                    (0, vue_1.createTextVNode)("Trade Income: Draw X cards and keep 1", -1)
                                                ]))])), [
                                                [_directive_i18n]
                                            ])
                                            : (_ctx.colony.name === _ctx.ColonyName.DEIMOS)
                                                ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_33, [...(_cache[29] || (_cache[29] = [
                                                        (0, vue_1.createTextVNode)("Trade Income: Erode X adjacent spaces", -1)
                                                    ]))])), [
                                                    [_directive_i18n]
                                                ])
                                                : (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_34, [...(_cache[30] || (_cache[30] = [
                                                        (0, vue_1.createTextVNode)("Trade Income", -1)
                                                    ]))])), [
                                                    [_directive_i18n]
                                                ])
            ]),
            (0, vue_1.createVNode)(_component_colony_row, {
                metadata: _ctx.metadata,
                colony: _ctx.colony
            }, null, 8, ["metadata", "colony"]),
            (0, vue_1.createVNode)(_component_colony_trade_row, { metadata: _ctx.metadata }, null, 8, ["metadata"])
        ])
    ], 10, _hoisted_1)), [
        [_directive_i18n]
    ]);
}
